import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_300, BLUE_500, Badge, Callout, Card, Divider, KeyPairUnit, StateConfigContext, Typography, WHITE, getTestId, isValidObject } from '@airtel/air-design-system';
import { useContext, useState, useEffect } from 'react';
import { TextInput, View } from 'react-native';
import { LinkListItemWidget } from '../link-list-item-widget';
import { getPaymentDetailsWidgetStyles } from './PaymentDetailsWidgetStyles';
export var PaymentDetailsWidgetComponent = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'PaymentDetail' : _props$testID,
    _props$badgeData = props.badgeData,
    badgeData = _props$badgeData === void 0 ? [] : _props$badgeData,
    _props$keyPairData = props.keyPairData,
    keyPairData = _props$keyPairData === void 0 ? {} : _props$keyPairData,
    _props$linkListItemPr = props.linkListItemProps,
    linkListItemProps = _props$linkListItemPr === void 0 ? {} : _props$linkListItemPr,
    _props$calloutProps = props.calloutProps,
    calloutProps = _props$calloutProps === void 0 ? {} : _props$calloutProps,
    _props$defaultAmount = props.defaultAmount,
    defaultAmount = _props$defaultAmount === void 0 ? '' : _props$defaultAmount,
    onChangeTextMetaData = props.onChangeTextMetaData,
    onUserAction = props.onUserAction,
    _props$hideInputSecti = props.hideInputSection,
    hideInputSection = _props$hideInputSecti === void 0 ? false : _props$hideInputSecti,
    _props$disableBadgePr = props.disableBadgePress,
    disableBadgePress = _props$disableBadgePr === void 0 ? false : _props$disableBadgePr,
    hintMsg = props.hintMsg,
    color = props.color,
    style = props.style,
    _props$isEditable = props.isEditable,
    isEditable = _props$isEditable === void 0 ? true : _props$isEditable,
    _props$showDivider = props.showDivider,
    showDivider = _props$showDivider === void 0 ? true : _props$showDivider,
    inputRegex = props.inputRegex,
    _props$onBlurMetaData = props.onBlurMetaData,
    onBlurMetaData = _props$onBlurMetaData === void 0 ? {} : _props$onBlurMetaData,
    _props$onFocusMetaDat = props.onFocusMetaData,
    onFocusMetaData = _props$onFocusMetaDat === void 0 ? {} : _props$onFocusMetaDat;
  var paymentDetailStyles = getPaymentDetailsWidgetStyles(Object.assign(Object.assign({}, props), {
    theme
  }));
  var _useState = useState(defaultAmount === null || defaultAmount === void 0 ? void 0 : defaultAmount.toString()),
    amount = _useState[0],
    setAmount = _useState[1];
  useEffect(() => {
    var amountString = defaultAmount === null || defaultAmount === void 0 ? void 0 : defaultAmount.toString();
    setAmount(amountString);
    if (amountString) {
      onChangeTextMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onChangeTextMetaData), {
        value: amountString
      }));
    }
  }, [defaultAmount]);
  var onBadgePress = function onBadgePress(value) {
    if (value === void 0) {
      value = '';
    }
    var finalValue = (Math.round((Number(amount) + Number(value)) * 100) / 100).toString() || '0';
    handleTextInput(finalValue);
  };
  var handleTextInput = text => {
    var isInvalid = inputRegex && !new RegExp(inputRegex).test(text);
    if (isInvalid) return;
    setAmount(text);
    onChangeTextMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onChangeTextMetaData), {
      value: text
    }));
  };
  return _jsxs(Card, Object.assign({
    paddingToken: "SPACING_0",
    style: [paymentDetailStyles.containerStyle, style]
  }, getTestId(testID, 'paymentDetailWrapper'), {
    children: [isValidObject(linkListItemProps) && _jsxs(_Fragment, {
      children: [_jsx(LinkListItemWidget, Object.assign({}, linkListItemProps)), showDivider && _jsx(View, Object.assign({
        style: paymentDetailStyles.dividerStyle
      }, {
        children: _jsx(Divider, {
          height: 2,
          shadowColor: WHITE
        })
      }))]
    }), !hideInputSection && _jsxs(View, Object.assign({
      style: [paymentDetailStyles.inputContainerStyle]
    }, {
      children: [amount.length > 0 && _jsx(Typography, {
        type: "h3-bold",
        text: "\u20B9",
        color: color
      }), _jsx(TextInput, Object.assign({
        style: [paymentDetailStyles.textInputStyle, {
          color
        }],
        cursorColor: BLUE_500,
        keyboardType: "numeric",
        inputMode: "numeric",
        value: amount,
        onChangeText: text => {
          handleTextInput(text);
        },
        placeholderTextColor: BLACK_300,
        placeholder: "Enter amount",
        editable: isEditable,
        onFocus: () => {
          onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onFocusMetaData));
        },
        onBlur: () => {
          onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onBlurMetaData));
        }
      }, getTestId(testID, 'textInput')))]
    })), !!hintMsg && _jsx(Typography, {
      style: paymentDetailStyles.hintMsgStyle,
      type: "body-para-xs",
      text: hintMsg,
      color: color
    }), (badgeData === null || badgeData === void 0 ? void 0 : badgeData.length) > 0 && _jsx(View, Object.assign({
      style: [paymentDetailStyles.gridStyle]
    }, {
      children: badgeData.map((item, index) => _jsx(View, Object.assign({
        style: paymentDetailStyles.gridItemStyle
      }, {
        children: _jsx(Badge, Object.assign({}, item, !disableBadgePress && {
          onPress: () => onBadgePress(item === null || item === void 0 ? void 0 : item.value)
        }))
      }), index))
    })), isValidObject(calloutProps) && _jsx(View, Object.assign({
      style: paymentDetailStyles.calloutStyle
    }, {
      children: _jsx(Callout, Object.assign({}, calloutProps))
    })), isValidObject(keyPairData) && _jsx(KeyPairUnit, Object.assign({
      style: paymentDetailStyles.keyPairContainerStyle,
      showDivider: false
    }, keyPairData))]
  }));
};
PaymentDetailsWidgetComponent.genericRendererKey = 'AirPaymentDetailsWidget';